import { component } from 'picoapp';

export default component((node) => {
  const placeholder = node.querySelector('[data-color-placeholder]');
  const colors = node.querySelectorAll('[data-color]');

  colors.forEach((item) => {
    if (!placeholder) return;

    item.addEventListener('mouseover', () => {
      const { color } = item.dataset;
      placeholder.innerHTML = color;
    });

    item.addEventListener('mouseleave', () => {
      placeholder.innerHTML = placeholder.dataset.original;
    });
  });
});
